<template>
  <div class="pdf-viewer-printer">
    <div class="input-container">
      <input
        v-model="pdfUrl"
        type="text"
        placeholder="输入OSS PDF链接"
        :disabled="isLoading"
      />
      <button @click="loadPdf" :disabled="isLoading || !pdfUrl">
        {{ buttonText }}
      </button>
    </div>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    <div ref="pdfContainer" class="pdf-container"></div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import * as pdfjsLib from 'pdfjs-dist';
//import 'pdfjs-dist/web/pdf_viewer.css';

export default {
  name: 'PdfViewerPrinter',
  setup() {
    const pdfUrl = ref('');
    const isLoading = ref(false);
    const errorMessage = ref('');
    const pdfContainer = ref(null);
    let pdfDoc = null;
    let pageNum = 1;
    let pageRendering = false;
    let pageNumPending = null;
    let scale = 1.5;

    const buttonText = computed(() => isLoading.value ? '加载中...' : '加载并打印');

    onMounted(() => {
      pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
    });

    function renderPage(num) {
      pageRendering = true;
      pdfDoc.getPage(num).then((page) => {
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        const renderTask = page.render(renderContext);

        renderTask.promise.then(() => {
          pageRendering = false;
          if (pageNumPending !== null) {
            renderPage(pageNumPending);
            pageNumPending = null;
          }
        });

        pdfContainer.value.innerHTML = '';
        pdfContainer.value.appendChild(canvas);
      });
    }

    function queueRenderPage(num) {
      if (pageRendering) {
        pageNumPending = num;
      } else {
        renderPage(num);
      }
    }

    function onPrevPage() {
      if (pageNum <= 1) {
        return;
      }
      pageNum--;
      queueRenderPage(pageNum);
    }

    function onNextPage() {
      if (pageNum >= pdfDoc.numPages) {
        return;
      }
      pageNum++;
      queueRenderPage(pageNum);
    }

    const loadPdf = async () => {
      if (!pdfUrl.value) return;

      isLoading.value = true;
      errorMessage.value = '';

      try {
        const loadingTask = pdfjsLib.getDocument(pdfUrl.value);
        pdfDoc = await loadingTask.promise;
        renderPage(pageNum);
        
        // 添加翻页按钮
        const prevButton = document.createElement('button');
        prevButton.textContent = '上一页';
        prevButton.onclick = onPrevPage;
        
        const nextButton = document.createElement('button');
        nextButton.textContent = '下一页';
        nextButton.onclick = onNextPage;
        
        const printButton = document.createElement('button');
        printButton.textContent = '打印';
        printButton.onclick = () => window.print();

        pdfContainer.value.appendChild(prevButton);
        pdfContainer.value.appendChild(nextButton);
        pdfContainer.value.appendChild(printButton);

      } catch (error) {
        console.error('PDF加载失败:', error);
        errorMessage.value = '无法加载PDF，请检查链接是否正确。';
      } finally {
        isLoading.value = false;
      }
    };

    return {
      pdfUrl,
      isLoading,
      errorMessage,
      buttonText,
      loadPdf,
      pdfContainer
    };
  }
}
</script>

<style scoped>
.pdf-viewer-printer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.input-container {
  display: flex;
  gap: 10px;
}

input {
  width: 300px;
  padding: 5px;
}

button {
  padding: 5px 10px;
}

.error-message {
  color: red;
}

.pdf-container {
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 10px;
}

@media print {
  .input-container, button {
    display: none;
  }
}
</style>